<script>
  import '@splidejs/svelte-splide/css';
  import { Splide, SplideSlide } from '@splidejs/svelte-splide';
  const flow_01 = "/assets_default/images/business/top/flow_01.webp"
  const flow_02 = "/assets_default/images/business/top/flow_02.webp"
  const flow_03 = "/assets_default/images/business/top/flow_03.webp"
  const flow_04 = "/assets_default/images/business/top/flow_04.webp"
  const documentIcon = "/assets_default/images/business/top/icon_document.svg"
  const myNumberCardIcon = "/assets_default/images/business/top/icon_my_number_card.svg"
  let slideList = [
    {
      src: flow_01,
      title: "情報入力"
    },
    {
      src: flow_02,
      title: "書類アップロード"
    },
    {
      src: flow_03,
      title: "口座開設完了"
    },
    {
      src: flow_04,
      title: "サービス利用開始"
    }
  ]
</script>

<section class="owd-biz-section:bg-gray account-section" id="account">
  <div class="owd-biz-section:max:1200">
    <section-head biz="true" title="口座開設方法" caption="ACCOUNT"></section-head>
    <p class="owd-heading:02 spacing:bottom:32">口座開設申込の条件</p>
    <ul class="owd-list owd-list:unordered owd-list:large spacing:bottom:64">
      <li>当行で口座開設できるのは、営利法人（株式会社、特例有限会社、合同会社、合名会社、合資会社）に限ります。</li>
      <li>申込み手続きは法人代表者が実施ください。（代表者以外は申込みいただけません。）</li>
      <li>1法人につき、普通預金口座を1口座のみ申込みできます。すでに当行と取引がある法人は申込みいただけません。</li>
    </ul>
    <div>
      <p class="owd-heading:02 spacing:bottom:32">必要書類</p>
      <div class="documents-wrap">
        <div class="documents-inner">
          <div class="documents-inner-icon">
            <img src="{documentIcon}" width="40" height="40" alt="書類アイコン">
          </div>
          <div>
            <p class="owd-heading:01 spacing:bottom:16">事業内容を確認できる書類（1～7から2点以上、ただし、1～4の中から必ず1点以上）</p>
            <ul class="owd-list owd-list:ordered owd-list:large spacing:bottom:16">
              <li>主たる事務所の建物賃貸借契約書</li>
              <li>取引先との押印済契約書</li>
              <li>他社発行の請求書、発注書、受注書、納品書のいずれか1点（※文房具など備品は対象外です。）</li>
              <li>国税または地方税の領収書、または納税証明書</li>
              <li>許認可証</li>
              <li>会社案内、パンフレット、提案資料、商品企画書、事業計画書 のいずれか1点</li>
              <li>自社発行の請求書、発注書、受注書、納品書のいずれか1点</li>
            </ul>
            <ul class="owd-list:annotation">
              <li>その他、追加で書類の提出をお願いすることがあります。</li>
            </ul>
          </div>
        </div>
        <div class="documents-inner">
          <div class="documents-inner-icon">
            <img src="{myNumberCardIcon}" width="40" height="40" alt="本人確認書類アイコン">
          </div>
          <div>
            <p class="owd-heading:01 spacing:bottom:16">代表者さまの本人確認書類</p>
            <ul class="owd-list owd-list:unordered owd-list:large spacing:bottom:16">
              <li>マイナンバーカード</li>
            </ul>
            <ul class="owd-list:annotation">
              <li>署名用電子証明書パスワードの入力が必要です。</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flow-section">
    <p class="owd-heading:02 spacing:bottom:32">手続きの流れ</p>

    <ul class="owd-carousel-wrap">
      <Splide
      options={{
        perPage:1.2,
        mediaQuery: 'min',
        gap: 16,
        focus: 0,
        perMove: 1,
        pagination: true,
        arrows: false,
        "breakpoints": {
          "425": {
            perPage:2.5,
          },
          "897": {
            destroy: true,
          }}
      }}>
      {#each slideList as item,i}
        <SplideSlide>
          <li class="owd-carousel-item owd-carousel-item:biz">
            <p class="owd-carousel-number align:center spacing:bottom:24"><span></span></p>
            <img class="spacing:bottom:24" src="{item.src}" alt="{item.title}">
            <p class="owd-heading:03 align:center">{item.title}</p>
          </li>
        </SplideSlide>
      {/each}
    </Splide>
    </ul>

    <ul class="owd-list:annotation">
      <li>
        法人口座の開設には審査があります。審査の過程で担当者よりWEB面談形式にて、事業内容や商取引の状況等について確認させていただく場合があります。また、審査の結果、口座開設をお断りすることがあります。
      </li>
    </ul>
  </div>
  <div class="account-section-last owd-biz-section:max:1200">
    <p class="owd-text:02"><a href="https://corporate.minna-no-ginko.com/for-safebanking/" target="_blank" class="owd-textlink"><strong>金融犯罪にご注意ください</strong></a></p>
  </div>
</section>

<style lang="scss">
.account-section{
  .documents{
    &-wrap{
      display: grid;
      gap: 80px;
      grid-template-columns: calc((718px/1200px)*100%) 1fr;
    }
    &-inner{
      display: grid;
      gap: 24px;
      grid-template-columns: 71px 1fr;
      &-icon{
        aspect-ratio: 1;
        background-color: var(--primary-white);
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: 40px;
        }
      }
    }
    @include g.mobile () {
      &-wrap{
        gap: 24px;
        grid-template-columns: 1fr;
      }
    }
  }
  .owd-biz-section\:max\:1200{
    margin-bottom: 64px;
  }
  &-last{
    margin-bottom: 0!important;
  }
  .flow-section{
    width: 90%;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 64px;
    .owd-carousel-wrap{
      margin-bottom: 32px;
    }
  }
  @include g.mobile () {
    background-color: var(--primary-white);
    padding-right: 0;
    .owd-biz-section\:max\:1200{
      margin-bottom: 40px;
      padding-right: 24px;
    }
    .owd-list.spacing\:bottom\:64{
      margin-bottom: 40px;
    }
    .flow-section{
      width: 100%;
      margin-bottom: 40px;
      .owd-carousel{
        &-wrap{
          margin-bottom: 24px;
          :global(.splide__list){
            margin-right: 24px!important;
          }
        }
        &-item{
          height: 100%;
        }
      }
    }
    .owd-heading\:02{
      @include g.owd-typography($fz: 'heading-3', $line-height-px: 32, $letter-spacing-tracking: 25, $font-weight: 600);
      padding: 2px 0;
      margin-bottom: 24px;
    }
  }
  :global(.flow-section .splide__list .splide__slide){
    height: auto;
  }
  @include g.large () {
    :global(.flow-section .splide__list){
      display: grid !important;
      grid-template-columns: repeat(4,1fr);
      gap:32px;
    }
  }
}
</style>
